  // Wait for the document to be fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Attach event listener to all buttons with class "load-metafields"
const buttons = document.querySelectorAll('.pill_link');

buttons.forEach(button => {
  button.addEventListener('click', function(evt) { 
    evt.preventDefault();

    // Remove 'active' from all product-pill elements
    document.querySelectorAll('.product-pill').forEach(el => {
      el.classList.remove('active');
    });

    // Add 'active' to the clicked button's parent .product-pill
    const pill = this.querySelector('.product-pill');
    if (pill) {
      pill.classList.add('active');
    }

    // Get the data-handle and call your function
    var productHandledefault = this.getAttribute('data-handle');
    
    if (productHandledefault.includes('/fr')) {
    var productHandle = this.getAttribute('data-handle').replace('/fr', '');
    var newUrl = '/fr/products/'+productHandle;
        //  console.log(newUrl);     
    }
    else{
    var productHandle = this.getAttribute('data-handle');
    var newUrl = '/products/'+productHandle;
    }
     window.history.pushState({}, '', newUrl);
    // console.log('productHandle: '+productHandle);
    updateProductMediaByHandle(productHandle);
    fetchProductMetafields(productHandle);

    
  });
});

  });

  
const pathParts = window.location.pathname.split('/');
const supportedLocales = ['fr', 'en']; // add your actual locales
const locale = supportedLocales.includes(pathParts[1]) ? pathParts[1] : 'en';

  // Function to fetch product metafields
  function fetchProductMetafields(handle) {
    fetch(`/products/${handle}?section_id=product-metafields&c=${locale}`)
      .then(response => response.text()) // Get the section HTML as text
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const jsonScript = doc.querySelector('#product-metafields-json script');
     
        // console.log(jsonScript)
        
        if (jsonScript) {
          const data = JSON.parse(jsonScript.textContent);
          // console.log(data,'DATA');
        //   console.log("Metafields:", data.metafields); // Use the metafields data as needed
        //   console.log(`Product: ${data.product_title} -- ${data.product_first_variant_id} \nMetafield: ${data.metafields['custom.flavor_name']}`);
        //  console.log('locale: '+locale); 

          var product_pack_name = data.product_pack_name;
            //  console.log(product_pack_name);  
          const product_pack_name_selector = document.querySelector('#MainContent .product__info-wrapper .pack_count p');
             if (product_pack_name_selector) {
              product_pack_name_selector.textContent = product_pack_name ;
            }

         var total_inventory = data.total_inventory;
    
        setTimeout(() => {
            const atc_ventory = document.querySelector('#MainContent .product__info-wrapper .product-form__submit');
            const atc_ventory_text = document.querySelector('#MainContent .product__info-wrapper .product-form__submit span');
            const atc_ventory_sticky = document.querySelector('#MainContent .sticky-container .product-form__submit');
            const atc_ventory_text_sticky = document.querySelector('#MainContent .sticky-container .product-form__submit span');

            if (!atc_ventory) {
              console.error('Add To Cart button not found');
            } else {
              if (total_inventory > 0) {
                console.log('inside total inventory block');
                console.log(document.querySelectorAll('.quantity__input'));
                document.querySelectorAll('.quantity__button').forEach(button => {
                  button.removeAttribute('disabled');
                  button.classList.remove('disabled');
                });
                // This is to disable the quantity when the varinats has 0 stocks.
                  document.querySelectorAll('.quantity__input').forEach(input => {
                    input.removeAttribute('disabled');

                    const currentQty = parseInt(input.value) || 1;

                    // Get max quantity dynamically
                    
                    const maxQty = parseInt(input.getAttribute('data-max-quantity')) || 20;
                    console.log('INPUT FOUND', input);

                    const dataQty = input.getAttribute('data-max-quantity');

                    console.log('data-max-quantity:', dataQty);

                    // Disable PLUS button if current qty reached max
                    if (currentQty >= maxQty) {
                      const plusButton = input.closest('.quantity')
                        ?.querySelector('.quantity__button[name="plus"]');

                      if (plusButton) {
                        plusButton.setAttribute('disabled', 'disabled');
                      }
                    }
                  });
                  //  console.log('Product total_inventory available: ' + total_inventory);     
                  if (atc_ventory_text && atc_ventory_text.parentElement) {
                      atc_ventory_text.parentElement.removeAttribute('disabled');
                    } else {
                      console.error('Element or parent button not found');
                    }

                    if (atc_ventory_text_sticky && atc_ventory_text_sticky.parentElement) {
                      atc_ventory_text_sticky.parentElement.removeAttribute('disabled');
                    } else {
                      console.error('Element or parent button not found');
                    }

                if (atc_ventory) {

                  if(locale == 'fr'){
                      atc_ventory_text.textContent = 'Ajouter au panier';
                      atc_ventory_text_sticky.textContent = 'Ajouter au panier';
                  }
                  else{
                      atc_ventory_text.textContent = 'Add To Cart';
                      atc_ventory_text_sticky.textContent = 'Add To Cart';
                  }
                }

              } else {
                const errorMessageWrapper = document.querySelector('.product-form__error-message-wrapper');
                const errorMessage = document.querySelector('.product-form__error-message');

                if (errorMessageWrapper) {
                  errorMessageWrapper.setAttribute('hidden', 'hidden');
                }

                if (errorMessage) {
                  errorMessage.textContent = '';
                }
                  // This is to disable the quantity when the varinats has 0 stocks.
                  document.querySelectorAll('.quantity__input').forEach(input => {
                    input.value = 1;
                    input.setAttribute('disabled', 'disabled');
                  });

                  document.querySelectorAll('.quantity__button').forEach(button => {
                    button.setAttribute('disabled', 'disabled');
                    button.classList.add('disabled');
                  });
                  //  console.log('Product total_inventory Sold Out');     
                  if (atc_ventory_text && atc_ventory_text.parentElement) {
                    atc_ventory_text.parentElement.setAttribute('disabled', 'disabled');
                  } else {
                    console.error('Element or parent button not found');
                  }
                  // Made changes due to translation from english to france  
                  if (locale == 'fr') {
                    atc_ventory_text.textContent = 'Épuisé';
                    atc_ventory_text_sticky.textContent = 'Épuisé';
                  } else {
                    atc_ventory_text.textContent = 'Sold Out';
                    atc_ventory_text_sticky.textContent = 'Sold Out';
                  }
                  
                  if (atc_ventory_text_sticky && atc_ventory_text_sticky.parentElement) {
                        atc_ventory_text_sticky.parentElement.setAttribute('disabled', 'disabled');
                      } else {
                        console.error('Element or parent button not found');
                      }
                  // if (atc_ventory) {
                  //   atc_ventory_text_sticky.textContent = 'Sold Out';
                  // } 
                }
            }
          }, 500);

          if(locale == 'fr'){
               var flavor = data.metafields['custom.flavor_name_fr'];
                //  console.log('flavor: '+flavor);     
            }
              else{
                 var flavor = data.metafields['custom.flavor_name'];
              }
        //  console.log('flavor: '+flavor);
           if(locale == 'fr'){
             var short_description = data.metafields['custom.short_description_fr'];
                //  console.log('short_description: '+short_description);     
            }
              else{
               var short_description = data.metafields['custom.short_description'];
              }
            if(locale == 'fr'){
          var benefits = data.metafields['custom.benefits_fr'];
                  //  console.log('benefits: '+benefits);     
            }
          else{
            var benefits = data.metafields['custom.benefits'];
                // console.log('benefits: '+benefits);     
          }
          const how_to_use = data.metafields['custom.how_to_use'];
          const ingredients = data.metafields['custom.ingredients'];
          const storage = data.metafields['custom.storage'];
          const warnings = data.metafields['custom.warnings'];
          const allergens = data.metafields['custom.allergens'];
          const default_variant_id = data.product_first_variant_id;
          const product_inventory = data.product_inventory;
          // console.log('product_inventory: ' + product_inventory);
          const images = data.product_images;
          const inputQtyInput = parseInt(document.querySelector('input[data-max-quantity]').value);
         // console.log(benefits);

          // Updates Products
          requestAnimationFrame(() => {
            document.dispatchEvent(
              new CustomEvent('onProductDataChange', {
                detail: { productChanged: true, inputCount: inputQtyInput }
              })
            );
          });

          // Product price for each variants this comes from product-metafields.liquid file
          const product_price = data.product_price;
          // console.log(product_price);
          // console.log("type:", typeof data.product_price);
          document.querySelectorAll(".custom_width.product__info-wrapper .pdp_price .price-item.price-item--regular").forEach(e=>{
            e.innerHTML = product_price}); 
                    
          const errorMessageForm = document.querySelector('.product-form__error-message-wrapper');

            if(errorMessageForm) {
                errorMessageForm.toggleAttribute('hidden', true);
            }
                  
          if (default_variant_id) {
                // Replace the inner HTML of the target element 
              const targets = document.querySelectorAll('.product__info-wrapper .product-variant-id, .custom-atc_wrapper .product-variant-id');

              targets.forEach(function(target) {
                if (target) {
                  target.value = default_variant_id;
                   target.dataset.availableQuantity = product_inventory;
                  // console.log(`default_variant_id updated: ${default_variant_id}`);
                }
              });

          } 
          if (flavor) {
            // Replace the inner HTML of the target element
            const target = document.querySelector('.product_flavour_name');
            if (target) {
              target.innerHTML = flavor;
              // console.log(`Flavor updated: ${flavor}`);
            }
          } 
            if (short_description) {
            const target = document.querySelector('.product__short_text p');
            if (target) {
              target.innerHTML = short_description;
              // console.log(`short_description updated: ${short_description}`);
            }
          } 
           if(locale == 'fr'){
          var rawText = data.metafields["custom.benefits_fr"];
           }
          else{
              var rawText = data.metafields["custom.benefits"];
          }
            if (rawText.startsWith('"') && rawText.endsWith('"')) {
            rawText = rawText.slice(1, -1);
            }

            const formattedHTML = rawText
              .split('\n\n') // Split paragraphs
              .map(p => `<p>${p.trim()}</p>`)
              .join('');
                // console.log(formattedHTML);     
           if (benefits) {
              document.querySelectorAll('.feature_benefits').forEach(el => {
                 el.innerHTML = formattedHTML;
              });
          } 

             if(locale == 'fr'){
                var rawText1 = data.metafields["custom.how_to_use_fr"];
             }
              else{
               var rawText1 = data.metafields["custom.how_to_use"];
            }
            if (rawText1.startsWith('"') && rawText1.endsWith('"')) {
            rawText1 = rawText1.slice(1, -1);
            }

            const formattedHTML_how_to_use = rawText1
              .split('\n\n') // Split paragraphs
              .map(p => `<p>${p.trim()}</p>`)
              .join('');
                // console.log(formattedHTML_how_to_use);     
           if (how_to_use) {
               document.querySelectorAll('.feature_how_to_use').forEach(el => {
                 el.innerHTML = formattedHTML_how_to_use;
                  // console.log(`how_to_use updated: ${how_to_use}`);
              });
          } 

           if(locale == 'fr'){
           var rawText2 = data.metafields["custom.ingredients_fr"];
             }
          else{
             var rawText2 = data.metafields["custom.ingredients"];
          }
            if (rawText2.startsWith('"') && rawText2.endsWith('"')) {
            rawText2 = rawText2.slice(1, -1);
            }

            const formattedHTML_ingredients = rawText2
              .split('\n\n') // Split paragraphs
              .map(p => `<p>${p.trim()}</p>`)
              .join('');
                // console.log(formattedHTML_ingredients);     
           
            if (ingredients) {
                document.querySelectorAll('.feature_nutritions___ingredients').forEach(el => {
                el.innerHTML = formattedHTML_ingredients;
                      // console.log(`ingredients updated: ${ingredients}`);      
                });
          } 
             if(locale == 'fr'){
                var rawText3 = data.metafields["custom.storage_fr"];
             }
            else{
               var rawText3 = data.metafields["custom.storage"];
            }
          

            if (rawText3.startsWith('"') && rawText3.endsWith('"')) {
            rawText3 = rawText3.slice(1, -1);
            }

            const formattedHTML_storage = rawText3
              .split('\n\n') // Split paragraphs
              .map(p => `<p>${p.trim()}</p>`)
              .join('');
                // console.log(formattedHTML_storage);     
          if (storage) {
                document.querySelectorAll('.feature_storage').forEach(el => {
                el.innerHTML = formattedHTML_storage;
                      // console.log(`feature_storage updated: ${storage}`);      
                });
          }
            if(locale == 'fr'){
           var rawText4 = data.metafields["custom.warnings_fr"];
            }
          else{
              var rawText4 = data.metafields["custom.warnings"];
          }
         

            if (rawText4.startsWith('"') && rawText4.endsWith('"')) {
            rawText4 = rawText4.slice(1, -1);
            }

            const formattedHTML_warnings = rawText4
              .split('\n\n') // Split paragraphs
              .map(p => `<p>${p.trim()}</p>`)
              .join('');
              //   console.log(formattedHTML_warnings);     
          if (warnings) {
                document.querySelectorAll('.feature_warnings').forEach(el => {
                el.innerHTML = formattedHTML_warnings;
                      // console.log(`feature_warnings updated: ${warnings}`);      
                });
          }
           if(locale == 'fr'){
          var rawText5 = data.metafields["custom.allergens_fr"];
           }
          else{
             var rawText5 = data.metafields["custom.allergens"];
          }

            if (rawText5.startsWith('"') && rawText5.endsWith('"')) {
            rawText5 = rawText5.slice(1, -1);
            }

            const formattedHTML_allergens = rawText5
              .split('\n\n') // Split paragraphs
              .map(p => `<p>${p.trim()}</p>`)
              .join('');
                // console.log(formattedHTML_allergens);     
          if (allergens) {
                document.querySelectorAll('.feature_allergens').forEach(el => {
                el.innerHTML = formattedHTML_allergens;
                  //  console.log(`feature_allergens updated: ${allergens}`); 
                });
          }
          
        } else {
          console.error("Metafield JSON not found for this product");
        }
      })
      .catch(err => console.error("AJAX Fetch error:", err));
  }

function updateProductMediaByHandle(handle) {
  // 🔥 Get dynamic section ID (VERY IMPORTANT)
  const viewerEl = document.querySelector('[id^="GalleryViewer"]');
  if (!viewerEl) return;

  const sectionId = viewerEl.id.replace('GalleryViewer-', '');

  fetch(`/products/${handle}?section_id=${sectionId}`)
    .then(res => res.text())
    .then(htmlString => {
      const html = new DOMParser().parseFromString(htmlString, 'text/html');

      // ✅ Get new elements
      const newViewer = html.querySelector(`#GalleryViewer-${sectionId}`);
      const newThumbnails = html.querySelector(`#GalleryThumbnails-${sectionId}`);

      // ✅ Get current elements
      const currentViewer = document.querySelector(`#GalleryViewer-${sectionId}`);
      const currentThumbnails = document.querySelector(`#GalleryThumbnails-${sectionId}`);

      // 🔥 Replace ENTIRE elements (not innerHTML)
      if (newViewer && currentViewer) {
        currentViewer.replaceWith(newViewer);
      }

      if (newThumbnails && currentThumbnails) {
        currentThumbnails.replaceWith(newThumbnails);
      }

      // ✅ ADD THIS BLOCK HERE
      setTimeout(() => {
        bindThumbnailsToMainImage(); // 🔥 rebind click events

        // 🔥 optional but recommended for Shopify themes
        document.dispatchEvent(new CustomEvent('shopify:section:load'));

      }, 50);
    })
    .catch(err => {
      console.error('Error updating product gallery:', err);
    });
}

function bindThumbnailsToMainImage() {
  const thumbnails = document.querySelectorAll('[data-thumbnail-id]');
  const mainImages = document.querySelectorAll('[data-media-id]');

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = thumb.getAttribute('data-thumbnail-id');

      // Remove active class from all slides
      mainImages.forEach(image => {
        image.classList.remove('is-active');
      });

      // Activate the selected main image
      const targetSlide = document.querySelector(`[data-media-id="${targetId}"]`);
      if (targetSlide) {
        targetSlide.classList.add('is-active');

        // Optional: scroll into view
        targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      thumbnails.forEach(t => {
        const btn = t.querySelector('button');
        if (btn) btn.removeAttribute('aria-current');
      });

      const activeBtn = thumb.querySelector('button');
      if (activeBtn) {
        activeBtn.setAttribute('aria-current', 'true');
      }
    });
  });
}


// Handle browser back/forward navigation for variant switching
// Updates desktop/mobile active states, media, and metafields

window.addEventListener('popstate', function () {

  const pathParts = window.location.pathname.split('/');
  const currentHandle = pathParts[pathParts.length - 1];

  const activePill = document.querySelector(
    `.pill_link[data-handle="${currentHandle}"]`
  );

  const activeDropdownItem = document.querySelector(
    `.dropdown-item[data-handle="${currentHandle}"]`
  );

  // Guard condition
  if (!activePill && !activeDropdownItem) {
      updateProductMediaByHandle(currentHandle);
      fetchProductMetafields(currentHandle);
      return;
  }

  // Desktop active state
  document.querySelectorAll('.product-pill').forEach(el => {
      el.classList.remove('active');
  });

  const pill = activePill?.querySelector('.product-pill');

  if (pill) {
      pill.classList.add('active');
  }

  // Mobile active state
  document.querySelectorAll('.dropdown-item').forEach(item => {
      item.classList.remove('active');
  });

  if (activeDropdownItem) {

      activeDropdownItem.classList.add('active');

      const selectedText = document.getElementById('dropdownSelectedText');

      const itemImg = activeDropdownItem.querySelector('img');
      const flavourText = activeDropdownItem.querySelector('.flavour_name');

      if (selectedText && itemImg && flavourText) {
        selectedText.innerHTML = `
          <img src="${itemImg.src}" alt="${itemImg.alt}">
          <span class="selected_flavour">${flavourText.textContent}</span>
        `;
      }
  }

  // Reload product data
  updateProductMediaByHandle(currentHandle);
  fetchProductMetafields(currentHandle);

});
